/**
 * Estimate scroll-video duration from the live preview DOM.
 *
 * Export re-lays credits out at the canonical width (Redux previewWidth =
 * 800) and scales frames to videoWidth, so height scales by
 * videoWidth / 800 on every device — never by the on-screen editor width,
 * which varies per monitor. The server prepends and appends one blank at
 * the top and bottom of the roll.
 *
 * Measured file lengths: heights under 2000px (e.g. 858, 960) match
 * content + both blanks; 2160p matches content + one viewport.
 */
const CANONICAL_LAYOUT_WIDTH = 800;

export function getScrollRunningTime({ videoWidth, videoHeight, sppf, fps }) {
  const blocks = document.querySelectorAll(".blockWrapper");
  const pxPerFrame = Number(sppf);
  const frameRate = Number(fps);

  if (!blocks.length || !pxPerFrame || !frameRate || !videoWidth || !videoHeight) {
    return { min: 0, sec: 0 };
  }

  const layoutScale = videoWidth / CANONICAL_LAYOUT_WIDTH;
  const contentHeight = Array.from(blocks).reduce(
    (sum, el) => sum + el.offsetHeight * layoutScale,
    0,
  );
  const padding = videoHeight >= 2000 ? videoHeight : 2 * videoHeight;
  const stripHeight = contentHeight + padding;

  const time = Math.max(0, stripHeight / (pxPerFrame * frameRate));

  return {
    min: Math.floor(time / 60),
    sec: Math.floor(time % 60),
  };
}
